import { Inject, Injectable } from '@angular/core'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'
import { AuthContextStorageService } from '../../core/auth/auth-context-storage.service'

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

    constructor(@Inject(AuthContextStorageService) private authContextStorageService: AuthContextStorageService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.authContextStorageService.getToken()) {
            return next.handle(req)
        }
        let newRequest = req.clone({
            headers: req.headers.append('Authorization', 'Bearer ' + this.authContextStorageService.getToken()),
        })
        return next.handle(newRequest)
    }
}
